import { render, staticRenderFns } from "./ProjectPublic.vue?vue&type=template&id=2d5c54ee"
import script from "./ProjectPublic.vue?vue&type=script&lang=js"
export * from "./ProjectPublic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports